export default "__VITE_ASSET__D6I2xZO6__"